import React, { memo, useState, useEffect, Fragment } from 'react';
import styles from '../../assets/scss/authentication.module.scss';
import 'react-phone-number-input/style.css';
import PhoneInput, { isValidPhoneNumber, parsePhoneNumber } from 'react-phone-number-input';
import { CloseCircleFilled } from '@ant-design/icons';
import { Alert, Form } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { CHECK_MOBILE, MOBILE_DETAILS } from '../../actions/types';
import FloatLabelInput from '../common/FloatLabelInput';

const MANDATORY_FIELDS_ERROR_MESSAGE = 'Please fill this mandatory field!';

function MobileNumber(props) {
  const { isParentError, validateAndHandleLogin, location } = props;
  const [error, setError] = useState('');
  const [focused, setFocused] = useState(false);
  const authentications = useSelector((state) => state.authentications);
  const [mobileNumber, setMobileNumber] = useState('' || (authentications.mobileDetails && authentications.mobileDetails.number));
  const listings = useSelector((state) => state.listings);
  const dispatch = useDispatch();

  useEffect(() => {
    if (authentications.mobileDetails && authentications.mobileDetails.number === undefined) {
      // setMobileNumber('');
    }
  }, [authentications]);

  useEffect(() => {
    if (isParentError && !mobileNumber) {
      setError(MANDATORY_FIELDS_ERROR_MESSAGE);
    }
  }, [isParentError]);

  const checkMobile = (number) => {
    dispatch({
      type: CHECK_MOBILE,
      payload: {
        mobileNum: number,
      },
    });
  };

  const onCountryChange = (value) => {
    if (value) {
      listings &&
        listings.countries &&
        listings.countries.length > 0 &&
        listings.countries.forEach((country) => {
          if (value === country.code) {
            dispatch({
              type: MOBILE_DETAILS,
              payload: {
                countryId: country.code === 'UM' ? 231 : country.id,
                country: country.code === 'UM' ? 'US' : country.code,
                countryCallingCode: '+' + country.phoneCode,
                nationalNumber: '',
                number: '',
              },
            });
          }
        });
    }
  };

  const onChange = (value) => {
    setMobileNumber(value);
    if (value) {
      dispatch({
        type: MOBILE_DETAILS,
        payload: {
          number: value.toString(),
        },
      });
    }
    if (value && value.length > 7 && isValidPhoneNumber(value)) {
      const phoneNumber = parsePhoneNumber(value);
      listings &&
        listings.status === 'success' &&
        listings.countries &&
        listings.countries.length > 0 &&
        listings.countries.forEach((country) => {
          if (country.code === phoneNumber.country) {
            dispatch({
              type: MOBILE_DETAILS,
              payload: {
                number: phoneNumber.number,
                nationalNumber: phoneNumber.nationalNumber,
                country: phoneNumber.country,
                countryId: country.id,
                countryCallingCode: phoneNumber.countryCallingCode,
              },
            });
          }
        });
      if (location !== 'login') {
        checkMobile(phoneNumber.nationalNumber);
      }
    } else {
      setError(isParentError && !mobileNumber ? MANDATORY_FIELDS_ERROR_MESSAGE : '');
    }
  };

  const onFocus = () => {
    setFocused(true);
  };

  const onBlur = () => {
    setFocused(false);
    if (mobileNumber && mobileNumber.length > 7 && !isValidPhoneNumber(mobileNumber)) {
      setError(`Oops! That doesn't like a valid phone number!`);
    } else {
      setError(isParentError && !mobileNumber ? MANDATORY_FIELDS_ERROR_MESSAGE : '');
    }
  };

  const handleEnterPress = (event) => {
    if (event.key === 'Enter' && validateAndHandleLogin) {
      validateAndHandleLogin();
    }
  };

  const clearField = () => {
    setMobileNumber('');
    dispatch({
      type: MOBILE_DETAILS,
      payload: {
        nationalNumber: '',
        number: '',
      },
    });
  };

  return (
    <Fragment>
      <FloatLabelInput label='Mobile Number *' name='mobileNumber' value={mobileNumber} className='PhoneInputFloat'>
        <div className={styles.allow_clear}>
          <Form.Item validateStatus={error ? 'error' : 'success'} help={error}>
            <PhoneInput
              international
              style={{ borderColor: error ? '#f96161' : '' }}
              countryCallingCodeEditable={false}
              defaultCountry={authentications && authentications.mobileDetails.country}
              placeholder='Mobile Number*'
              value={mobileNumber}
              limitMaxLength={true}
              className={focused ? 'focused' : null}
              onChange={onChange}
              onCountryChange={onCountryChange}
              onFocus={onFocus}
              onBlur={onBlur}
              onKeyPress={handleEnterPress}
              autoComplete='none'
            />
          </Form.Item>

          {mobileNumber && mobileNumber.length >= 1 ? <CloseCircleFilled onClick={clearField} /> : null}
        </div>
      </FloatLabelInput>
    </Fragment>
  );
}

export default memo(MobileNumber);
